export function ErrorMessages({ errors }) {
  if (errors) return <p className="text-red-500">{errors}</p>;
  return <></>;
}
